import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import RequestDemo from "./requestDemo";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RequestDemo />
  </React.StrictMode>
);

reportWebVitals();
